import { Category } from '@modules/common/types';
import { Theme } from '@mui/material';

interface GetCategoryColorFromTheme {
  theme: Theme;
  category: Category;
}

export const getCategoryColorFromTheme = ({
  theme,
  category,
}: GetCategoryColorFromTheme) => {
  switch (category) {
    case Category.Improvement:
      return theme.palette.category?.improvement;
    case Category.Complaint:
      return theme.palette.category?.complaint;
    case Category.Help:
      return theme.palette.category?.help;
    case Category.Praise:
      return theme.palette.category?.praise;
    default:
      return theme.palette.text.secondary;
  }
};
